<mat-spinner [diameter]="50"></mat-spinner>
<span class="percentage">{{percentage}}</span>
<span class="message">{{message}}</span>
